import React, { ReactNode, useContext } from 'react';
import { AppContext } from '../app/AppProvider.component';
import { FlexLayout } from '../flex/FlexLayout.component';
import { FlexItem } from '../flex/FlexItem.component';
import { FlexLayoutModifier } from '../flex/flex.constants';
import {
    RecommendationAttemptDto,
    RecommendationDto,
    StatusWithDueDate,
} from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import { StatusPill } from '../status-pill/StatusPill.component';
import { RemediationContentTypeConfigMap } from '../../models/remediation.models';
import { StatusDisplayMap } from '../../constants/remediation.constants';
import {
    getHourAndMinuteFromSecond,
    getRecommendationStatusWithDueDate
} from '../../utilities/remediation.utilities';
import moment from 'moment';
import { ELSIcon } from '../els.components';

export type RecommendationCardProps = {
    recommendation: RecommendationDto;
    recommendationAttempts: RecommendationAttemptDto[];
    isExpanded: boolean;
    handleLaunch: (recommendation: RecommendationDto) => void;
    launchButtonText: string;
    banner: ReactNode;
};

const RecommendationCard = (props: RecommendationCardProps): JSX.Element => {

    const { appState } = useContext(AppContext);
    const baseState = appState.remediationBaseState;

    const {
        recommendation
    } = props;

    if (!recommendation) {
        return null;
    }

    const getTopics = () => {
        return null;
    };

    const getSubtitle = () => {
        return null;
    };

    const getContentTypeAndTimeEstimateSubtitleDisplay = () => {
        return (
            <div className="u-els-nowrap">
                <span>{RemediationContentTypeConfigMap[recommendation.contentType].displayName}</span>
                <span>&nbsp;&bull;&nbsp;</span>
                <span className="u-els-color-n8">
                    est. {getHourAndMinuteFromSecond(moment.duration(recommendation.estimatedTime).asSeconds())}
                </span>
            </div>
        )
    }

    const status = getRecommendationStatusWithDueDate({
        recommendation: props.recommendation,
        baseState
    });

    const contentTypeConfig = RemediationContentTypeConfigMap[recommendation.contentType];

    return (
        <button
            onClick={() => props.handleLaunch(props.recommendation)}
            className={`u-els-debuttonize c-ssa-recommendation-card c-ssa-recommendation-card--${contentTypeConfig.activityType.toLowerCase()}`}
        >
            {
                props.banner && (
                    <div className="c-ssa-recommendation-card__banner">
                        {props.banner}
                    </div>
                )
            }

            <div className="c-ssa-recommendation-card__main">
                <FlexLayout modifiers={[FlexLayoutModifier.MIDDLE, FlexLayoutModifier.LEFT]}>
                    <FlexItem classes={['u-els-margin-right-1o2']}>
                        <ELSIcon
                            size="2x"
                            name={RemediationContentTypeConfigMap[recommendation.contentType].iconName}
                            prefix={RemediationContentTypeConfigMap[recommendation.contentType].iconPrefix}
                        />
                    </FlexItem>

                    <FlexItem>
                        <h3 className="u-els-display-block"><strong>{recommendation.title}</strong></h3>
                        <FlexItem>
                            {getContentTypeAndTimeEstimateSubtitleDisplay()}
                        </FlexItem>
                    </FlexItem>
                </FlexLayout>
            </div>

            {props.isExpanded && (
                <div>
                    <div className="c-els-divider--1o2 c-els-divider--n3" />

                    <div className="c-ssa-recommendation-card__subsection">
                        {getSubtitle() && (
                            <div className="o-els-container">
                                {getSubtitle()}
                            </div>
                        )}

                        <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS_2X, FlexLayoutModifier.BOTTOM]}>
                            <FlexItem isRender={status !== StatusWithDueDate.NOT_STARTED}>
                                <StatusPill status={status}>
                                    {StatusDisplayMap[status]}
                                </StatusPill>
                            </FlexItem>
                            <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
                                {getTopics() && (
                                    <div>
                                        <div>Topics covered:</div>
                                        {
                                            getTopics().map((topic) => {
                                                return (
                                                    <div key={topic}>{topic}</div>
                                                );
                                            })
                                        }
                                    </div>
                                )}
                            </FlexItem>
                            <FlexItem>
                                <span className="u-els-anchorize u-els-display-block">
                                    {props.launchButtonText}
                                </span>
                            </FlexItem>
                        </FlexLayout>
                    </div>
                </div>
            )}
        </button>
    );
};
export default RecommendationCard;
